import PlayerCard from "../components/playerCard";

function Test() {
    return (
        <div >
            <PlayerCard name="Lionnel Messi" gender="Male" Age= "36" bpm="90" playtime="1 hours" visibility="true"/>
            <h1>TESSS</h1>
        </div>
    )
}

export default Test;